import * as API_CONSTANT from '../constants'
import { report_handler } from '../../../handlers'

export const getDriverReportSummary = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/report/dailyperformance/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getDeviceReportSummary = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/device/log/derivative/timeframe/get/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'reports', 10000))
)

